import InvoiceSearch from '@/pages/invoiceManage/invoiceSearch'

export default [
  {
    path: '/InvoiceSearch',
    name: 'InvoiceSearch',
    component: InvoiceSearch,
    meta: { name: '发票查询' }
  }
]



// WEBPACK FOOTER //
// ./src/router/invoiceManage/invoiceSearch.js